import { render, staticRenderFns } from "./GmbServices.vue?vue&type=template&id=7660b9c0&scoped=true&"
import script from "./GmbServices.vue?vue&type=script&lang=js&"
export * from "./GmbServices.vue?vue&type=script&lang=js&"
import style0 from "./GmbServices.vue?vue&type=style&index=0&id=7660b9c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7660b9c0",
  null
  
)

export default component.exports